export const translations = {
  english: {
    eventRegistration: {
      title: 'Register for Monthly Event',
      eventTitle: 'Monthly Event',
      successMessage: 'Registration successful! We look forward to seeing you at the event.'
    },
    pastors: {
      meetOurPastor: "Meet Our Pastor",
      meetOurPastorDescription: "Meet our pastor, a dedicated leader guiding our community in faith and love.",
      pastorName: "SILUVAI RAJA",
      pastorRole: "Pastor",
      pastorDescription: "A dedicated spiritual leader with over 15 years of experience in ministry.",
      callNow: "Call Now",
      whatsapp: "WhatsApp",
    },


    eventCountdown: {
      upcomingEvent: 'UPCOMING EVENT',
      celebrationTitle: 'A Celebration of Community',
      startTime: 'Start Time',
      time: '06:00 pm',
      location: 'Location',
      address: 'Ark of Jesus Christ Ministries, 40/2, 7th Main Road, 12th Cross Street, Pudu Nallur, Kundrathur, Chennai 69.',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Mins',
      seconds: 'Secs',
      allEventsButton: 'All Events'
    },
    // Navigation
    home: 'Home',
    about: 'About',
    sermons: 'Sermons',
    events: 'Events',
    pastorsNav: 'Pastors',
    admin: 'Admin',

    // Header
    welcomeTitle: 'Welcome to the glory of God!',
    churchDescription: 'Join us at "AJC SILUVAIRAJA MINISTRY" Church, where love and acceptance thrive. Embrace divine glory and connect with others in a vibrant, faith-filled community!',
    joinUsNow: 'Join Us Now →',

    // Sermons Section
    latestSermons: 'Latest Sermons',
    watchNow: 'Watch Now',
    viewAllSermons: 'View All Sermons',
    findingStrength: 'Finding Strength in God\'s Promises',
    insightsOfFaith: 'Insights of Faith: Finding Peace in Uncertain Times',
    walkingInFaith: 'Walking in Faith: Trust Beyond Sight',
    agapeLove: 'Agape - Embracing Divine Love',

    // Events Section
    upcomingEvents: 'Upcoming Events',
    eventCalendar: 'Events Calendar',
    registerNow: 'Register Now',
    wonderfulGathering: 'Wonderful and Relaxing Gatherings',
    buildingBonds: 'Building Bonds In Christ',
    thankfulness: 'Thankfulness And Giving',
    faithFellowship: 'Faith And Fellowship Night',
    youthGathering: 'Youth Ministry Gathering',
    prayerService: 'Prayer And Worship Service',
    eventDate: 'Event Date',
    eventTime: 'Event Time',
    eventLocation: 'Location',

    // Registration Form
    registrationTitle: ' {eventName}',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone Number',
    attendeeCount: 'Number of People Attending',
    submit: 'Register Now',

    // Blog Section
    blogTitle: 'Latest Articles',
    readMore: 'Read More',
    subscribe: 'Subscribe',
    subscribeText: 'Subscribe to our blog for the latest posts and insights!',

    blog: {
      latestArticles: 'Latest Articles',
      subscribeText: 'Subscribe to our blog for the latest posts and insights!',
      article1: {
        title: 'Impacting Lives: Stories Of Faith In Action',
        description: 'Discover powerful stories where faith and compassion unite to create lasting impact in lives and communities.'
      },
      article2: {
        title: 'Maintaining Faith During Life\'s Greatest Challenges',
        description: 'In difficult times, faith that gives strength in every trial provides the necessary strength and hope to face life\'s toughest challenges.'
      },
      article3: {
        title: 'Building Community: The Importance Of Fellowship',
        description: 'Discover how building meaningful connections and fostering fellowship strengthens communities, creating a sense of belonging and support.'
      },
      viewAll: 'View All Articles',
    },
    // Testimonials Section
    testimonials: {
      title: 'Testimonials',
      sarahName: 'Sarah Thomas',
      sarahRole: 'Church Member',
      sarahQuote: 'This church has been a blessing to my family. The community is welcoming and the sermons are inspiring.',
      johnName: 'John Davis',
      johnRole: 'Youth Group Leader',
      johnQuote: 'I\'ve seen so many young lives transformed through our youth ministry. God is truly working in this place.',
      maryName: 'Mary Johnson',
      maryRole: 'Choir Member',
      maryQuote: 'The worship experience here is amazing. I feel God\'s presence every time we gather together.',
    },
    // Contact Section
    contactUs: 'Contact Us',
    message: 'Message',
    sendMessage: 'Send Message',
    contact: {
      title: 'Contact Us',
      nameLabel: 'Name',
      emailLabel: 'Email',
      messageLabel: 'Message',
      submitButton: 'Send Message'
    },

    // Footer
    footer: {
      church: "Main Church in Periyarnagar, Kundrathur, Chennai.",
      branch: "Branch in Pudhunallur, Kundrathur, Chennai.",
      phone: "Phone",
      whatsapp: "WhatsApp",
      support: "Support Email",
      newsletter: "Newsletter",
      emailPlaceholder: "Enter your email",
      newsletterText: "Get weekly updates from our ministry.",
      quickLinks: "Quick Links",
      workingHours: "Working Hours",
      monFri: "Mon - Fri: 9 AM to 5 PM",
      sat: "Saturday: 10 AM to 2 PM",
      sun: "Sunday: Closed",
      followUs: "Follow Us",
      locationTitle: "Locate Us",
      mainBranchLabel: "Kundrathur AJC Church & Office House",
      branchLabel: "Branch Location",
      allRightsReserved: "All rights reserved",
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy"
    },

    // Dashboard
    dashboard: 'Event Registration Dashboard',
    totalRegistrations: 'Total Registrations',
    totalAttendees: 'Total Attendees',
    confirmed: 'Confirmed',
    pending: 'Pending',
    cancelled: 'Cancelled',
    search: 'Search',
    exportCSV: 'Export to CSV',
    loading: 'Loading registrations...',
    noResults: 'No registrations found',

    // Additional translations
    faithChallenges: 'Faith Challenges',
    buildingCommunity: 'Building Community',
    discipleship: 'Village Ministry',
    actsOfKindness: 'Acts of Kindness',
    kindnessInAction: 'Kindness in Action',
    impactingLives: 'Impacting Lives Through Faith',
    blogDate1: 'December 15, 2024',
    blogDate2: 'December 10, 2024',
    blogDate3: 'December 5, 2024',
    blogDate4: 'December 1, 2024',
    faithChallengesExcerpt: "Exploring the challenges we face in our faith journey and how to overcome them with God's help...",
    buildingCommunityExcerpt: "How to build strong community bonds in your church and create lasting relationships...",
    discipleshipExcerpt: "Bringing hope and ministry to rural communities through dedicated outreach programs...",
    actsOfKindnessExcerpt: "Small acts of kindness that make a big difference in people's lives...",
    kindnessInActionExcerpt: "Real stories of compassion in our community and how we can all make a difference...",
    churchAddress: 'Ark of Jesus Christ Ministries, 40/2, 7th Main Road, 12th Cross Street, Pudu Nallur, Kundrathur, Chennai 69.',
    workingHoursLabel: 'Mon-Sun: 9:00 AM - 6:00 PM',
    related: 'Related',
    buyNow: 'Buy Now',
    backToBlog: 'Back to Blog',
    shareArticle: 'Share Article',
    relatedPosts: 'Related Posts'
  },

  tamil: {
    eventRegistration: {
      title: 'மாதாந்திர நிகழ்வுக்கு பதிவு செய்யவும்',
      eventTitle: 'நடத்தும் மாதாந்திர நிகழ்ச்சியில் கலந்துகொள்ள முன்பதிவு செய்ய அழைக்கப்படுகிறது',
      successMessage: 'பதிவு வெற்றிகரமாக முடிந்தது! நிகழ்வில் உங்களை சந்திப்பதை எதிர்நோக்குகிறோம்.'
    },
    pastors: {
      meetOurPastor: "எங்கள் பாதரியைச் சந்தியுங்கள்",
      meetOurPastorDescription: "எங்கள் பாதிரி, நம்பிக்கை மற்றும் அன்பில் எங்கள் சமூகத்தை வழிநடத்தும் ஒரு அர்ப்பணிப்புடன் செயல்படும் தலைவரைச் சந்தியுங்கள்.",
      pastorName: "சிலுவை ராஜா",
      pastorRole: "பாதிரி",
      pastorDescription: "15 ஆண்டுகளுக்கும் மேலான ஊழிய அனுபவம் கொண்ட அர்ப்பணிப்புடன் செயல்படும் ஆன்மிகத் தலைவர்.",
      callNow: "உடனே அழைக்கவும்",
      whatsapp: "வாட்ஸ்அப்",
    },

    eventCountdown: {
      upcomingEvent: 'வரவிருக்கும் நிகழ்வு',
      celebrationTitle: 'சமூக கொண்டாட்டம்',
      startTime: 'தொடக்க நேரம்',
      time: 'மாலை 06:00',
      location: 'இடம்',
      address: 'ஆர்க் ஆஃப் ஜீசஸ் கிறிஸ்ட் மினிஸ்ட்ரீஸ், 40/2, 7வது மெயின் ரோடு, 12வது குறுக்கு தெரு, புது நல்லூர், குன்றத்தூர், சென்னை 69.',
      days: 'நாட்கள்',
      hours: 'மணி',
      minutes: 'நிமிடம்',
      seconds: 'வினாடி',
      allEventsButton: 'அனைத்து நிகழ்வுகள்'
    },

    // Navigation
    home: 'முகப்பு',
    about: 'எங்களை பற்றி',
    sermons: 'பிரசங்கங்கள்',
    events: 'நிகழ்வுகள்',
    pastorsNav: 'பாஸ்டர்கள்',
    admin: 'நிர்வாகி',

    // Header
    welcomeTitle: 'கடவுளின் மகிமைக்கு வரவேற்கிறோம்!',
    churchDescription: 'அன்பும் ஏற்றுக்கொள்ளுதலும் செழிக்கும் AJC சிலுவைராஜா மினிஸ்ட்ரி தேவாலயத்தில் எங்களுடன் இணையுங்கள். தெய்வீக மகிமையை உணர்ந்து, நம்பிக்கை நிறைந்த சமூகத்துடன் இணையுங்கள்!',
    joinUsNow: 'இப்போது இணையுங்கள் →',

    // Sermons Section
    latestSermons: 'சமீபத்திய பிரசங்கங்கள்',
    watchNow: 'இப்போது பார்க்க',
    viewAllSermons: 'அனைத்து பிரசங்கங்களையும் காண',
    findingStrength: 'கடவுளின் வாக்குறுதிகளில் வலிமையைக் கண்டறிதல்',
    insightsOfFaith: 'விசுவாசத்தின் நுண்ணறிவுகள்: நிச்சயமற்ற நேரங்களில் அமைதியைக் கண்டறிதல்',
    walkingInFaith: 'விசுவாசத்தில் நடத்தல்: பார்வைக்கு அப்பாற்பட்ட நம்பிக்கை',
    agapeLove: 'அகாபே - தெய்வீக அன்பை ஏற்றுக்கொள்ளுதல்',

    // Events Section
    upcomingEvents: 'வரவிருக்கும் நிகழ்வுகள்',
    eventCalendar: 'நிகழ்வுகள் நாள்காட்டி',
    registerNow: 'இப்போது பதிவு செய்யவும்',
    wonderfulGathering: 'அற்புதமான மற்றும் ஓய்வளிக்கும் கூட்டங்கள்',
    buildingBonds: 'கிறிஸ்துவில் பிணைப்புகளை உருவாக்குகிறது',
    thankfulness: 'நன்றியுணர்வு மற்றும் கொடுத்தல்',
    faithFellowship: 'விசுவாசம் மற்றும் ஐக்கிய இரவு',
    youthGathering: 'இளைஞர் ஊழிய கூட்டம்',
    prayerService: 'ஜெப மற்றும் ஆராதனை சேவை',
    eventDate: 'நிகழ்வு தேதி',
    eventTime: 'நிகழ்வு நேரம்',
    eventLocation: 'இடம்',

    // Registration Form
    registrationTitle: '{eventName}க்கு பதிவு செய்யவும்',
    fullName: 'முழு பெயர்',
    email: 'மின்னஞ்சல்',
    phone: 'தொலைபேசி எண்',
    attendeeCount: 'கலந்து கொள்ளும் நபர்களின் எண்ணிக்கை',
    submit: 'இப்போது பதிவு செய்யவும்',

    // Blog Section
    blogTitle: 'சமீபத்திய கட்டுரைகள்',
    readMore: 'மேலும் படிக்க',
    subscribe: 'குழு சேர',
    subscribeText: 'சமீபத்திய பதிவுகள் மற்றும் நுண்ணறிவுகளுக்கு எங்கள் வலைப்பதிவில் சந்தா செய்யுங்கள்!',

    blog: {
      latestArticles: 'சமீபத்திய கட்டுரைகள்',
      subscribeText: 'சமீபத்திய பதிவுகள் மற்றும் நுண்ணறிவுகளுக்கு எங்கள் வலைப்பதிவில் சந்தா செய்யுங்கள்!',
      article1: {
        title: 'வாழ்க்கைகளில் தாக்கம்: நம்பிக்கையின் கதைகள்',
        description: 'நம்பிக்கை மற்றும் கருணை இணைந்து வாழ்க்கை மற்றும் சமூகங்களில் நீடித்த தாக்கத்தை உருவாக்கும் சக்திவாய்ந்த கதைகளைக் கண்டறியவும்.'
      },
      article2: {
        title: 'வாழ்க்கையின் மிகப்பெரிய சவால்களின் போது நம்பிக்கையை பராமரித்தல்',
        description: 'கடினமான நேரங்களில், ஒவ்வொரு சோதனையிலும் வலிமையை அளிக்கும் நம்பிக்கை வாழ்க்கையின் கடினமான சவால்களை எதிர்கொள்ள தேவையான வலிமையையும் நம்பிக்கையையும் வழங்குகிறது.'
      },
      article3: {
        title: 'சமூக கட்டமைப்பு: ஐக்கியத்தின் முக்கியத்துவம்',
        description: 'அர்த்தமுள்ள தொடர்புகளை உருவாக்குவது மற்றும் ஐக்கியத்தை வளர்ப்பது எவ்வாறு சமூகங்களை வலுப்படுத்துகிறது, சொந்தம் மற்றும் ஆதரவின் உணர்வை உருவாக்குகிறது என்பதைக் கண்டறியவும்.'
      },
      viewAll: 'அனைத்து கட்டுரைகளையும் காண்க',
    },

    // Testimonials Section
    testimonials: {
      title: 'சான்றுகள்',
      sarahName: 'சாரா தாமஸ்',
      sarahRole: 'சபை உறுப்பினர்',
      sarahQuote: 'இந்த தேவாலயம் என் குடும்பத்திற்கு ஒரு ஆசீர்வாதமாக உள்ளது. இங்குள்ள சமூகம் வரவேற்கத்தக்கது மற்றும் பிரசங்கங்கள் எழுச்சியூட்டுகின்றன.',
      johnName: 'ஜான் டேவிஸ்',
      johnRole: 'இளைஞர் குழு தலைவர்',
      johnQuote: 'எங்கள் இளைஞர் ஊழியத்தின் மூலம் பல இளைஞர்களின் வாழ்க்கையில் மாற்றம் ஏற்படுவதை நான் பார்த்திருக்கிறேன். தேவன் உண்மையில் இந்த இடத்தில் செயல்படுகிறார்.',
      maryName: 'மேரி ஜான்சன்',
      maryRole: 'பாடகர் குழு உறுப்பினர்',
      maryQuote: 'இங்குள்ள ஆராதனை அனுபவம் அற்புதமானது. நாம் ஒன்றாக கூடும் ஒவ்வொரு முறையும் நான் தேவனுடைய பிரசன்னத்தை உணர்கிறேன்.',
    },

    // Contact Section
    contactUs: 'எங்களை தொடர்பு கொள்ள',
    message: 'செய்தி',
    sendMessage: 'செய்தி அனுப்பு',
    contact: {
      title: 'தொடர்பு கொள்ளவும்',
      nameLabel: 'பெயர்',
      emailLabel: 'மின்னஞ்சல் முகவரி',
      messageLabel: 'உங்கள் செய்தி',
      submitButton: 'அனுப்புக'
    },

    // Footer
    footer: {
      church: 'AJC சிலுவைராஜா மினிஸ்ட்ரி',
      branch: 'புது நல்லூர் கிளை',
      phone: 'தொலைபேசி',
      whatsapp: 'வாட்ஸ்அப்',
      support: 'ஆதரவு',
      quickLinks: 'விரைவு இணைப்புகள்',
      workingHours: 'வேலை நேரம்',
      followUs: 'எங்களை பின்தொடரவும்',
      newsletter: 'அனைத்து முக்கிய செய்திகளுக்கும் குழு சேரவும்!',
      newsletterText: 'எங்களின் சமீபத்திய செய்திகள் மற்றும் நிகழ்வுகளைப் பற்றிய புதுப்பிப்புகளுக்குப் பதிவு செய்யவும்.',
      emailPlaceholder: 'உங்கள் மின்னஞ்சலை உள்ளிடவும்',
      monFri: 'திங்கள்-வெள்ளி: காலை 6:00 - மாலை 7:00',
      sat: 'சனி: காலை 6:00 - மாலை 7:00',
      sun: 'ஞாயிறு: காலை 6:00 - மாலை 7:00',
      locationTitle: 'எங்களை கண்டுபிடிக்க',
      mainBranchLabel: 'குன்றத்தூர் AJC சபை & அலுவலக வீடு',
      branchLabel: 'கிளை சபை',
      termsOfService: 'சேவை விதிமுறைகள்',
      privacyPolicy: 'தனியுரிமைக் கொள்கை',
      cookiePolicy: 'குக்கீ கொள்கை',
      allRightsReserved: 'அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை'
    },

    // Dashboard
    dashboard: 'நிகழ்வு பதிவு டாஷ்போர்டு',
    totalRegistrations: 'மொத்த பதிவுகள்',
    totalAttendees: 'மொத்த பங்கேற்பாளர்கள்',
    confirmed: 'உறுதிப்படுத்தப்பட்டது',
    pending: 'நிலுவையில்',
    cancelled: 'ரத்து செய்யப்பட்டது',
    search: 'தேடல்',
    exportCSV: 'CSV க்கு ஏற்றுமதி',
    loading: 'பதிவுகளை ஏற்றுகிறது...',
    noResults: 'பதிவுகள் கிடைக்கவில்லை',

    // Additional Tamil translations
    faithChallenges: 'நம்பிக்கையின் சவால்கள்',
    buildingCommunity: 'சமூகத்தைக் கட்டியெழுப்புதல்',
    discipleship: 'கிராம சேவை',
    actsOfKindness: 'அன்பு செயல்கள்',
    kindnessInAction: 'அன்பு செயல்களில்',
    impactingLives: 'நம்பிக்கையின் மூலம் வாழ்க்கைகளை மாற்றுதல்',
    blogDate1: 'டிசம்பர் 15, 2024',
    blogDate2: 'டிசம்பர் 10, 2024',
    blogDate3: 'டிசம்பர் 5, 2024',
    blogDate4: 'டிசம்பர் 1, 2024',
    faithChallengesExcerpt: 'நாம் நம்பிக்கையில் சந்திக்கும் சவால்களை ஆராய்வதும், தேவனின் உதவியுடன் அதைப் எப்படி கடக்கலாம் என்பதையும் பற்றி...',
    buildingCommunityExcerpt: 'உங்கள் தேவாலயத்தில் உறுதியான சமூக பிணைப்புகளை உருவாக்குவது எப்படி மற்றும் நிலையான உறவுகளை உருவாக்குவது...',
    discipleshipExcerpt: 'அர்ப்பணிப்பு நிறைந்த சேவை முயற்சிகள் மூலம் கிராம பகுதிகளுக்கு நம்பிக்கையையும் சேவையையும் கொண்டு செல்லுதல்...',
    actsOfKindnessExcerpt: 'மிகச் சிறிய அன்பு செயல்களும் மக்களின் வாழ்க்கையில் பெரிய மாற்றங்களை ஏற்படுத்துகின்றன...',
    kindnessInActionExcerpt: 'எங்கள் சமூகத்தில் காணப்படும் அன்பின் உண்மையான கதைகள் மற்றும் நாமும் எப்படி ஒரு மாற்றத்தை ஏற்படுத்தலாம் என்பதைக் குறித்து...',
    churchAddress: 'ஆர்க் ஆஃப் ஜீசஸ் கிறிஸ்ட் மினிஸ்ட்ரீஸ், 40/2, 7வது மெயின் ரோடு, 12வது குறுக்கு தெரு, புது நல்லூர், குன்றத்தூர், சென்னை 69.',
    workingHours: 'திங்கள் - ஞாயிறு: காலை 9:00 - மாலை 6:00',
    related: 'தொடர்புடையவை',
    buyNow: 'இப்போது வாங்கவும்',
    backToBlog: 'பதிவுகள் பக்கத்திற்கு திரும்பு',
    shareArticle: 'கட்டுரையை பகிரவும்',
    relatedPosts: 'தொடர்புடைய பதிவுகள்'
  }
};
